import React from 'react';
import { Box, Container } from '@mui/material';
import HeroBanner from '../../components/home/hero-banner';
import InstitutionalHeroBanner from '../../components/home/institutional-hero-banner';
import { useHomeState } from '../context/home-context';

// Hero na mesma largura do corpo do site (container), com respiro abaixo da navegação.
// Sem banners cadastrados no APM (ou se a lista falhar), exibe os banners institucionais
export default function SectionBanner() {
  const { banners } = useHomeState();
  const hasBanners = !!banners?.length;

  return (
    <Box component="section" aria-label="Destaques" sx={{ py: { xs: 2, md: 3 } }}>
      <Container maxWidth="xl">
        {hasBanners ? <HeroBanner banners={banners} /> : <InstitutionalHeroBanner />}
      </Container>
    </Box>
  );
}
